var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRedimensionar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    d: "M31.6,35.5H4.4c-2.2,0-3.9-1.7-3.9-3.9V4.4c0-2.2,1.7-3.9,3.9-3.9h27.3c2.2,0,3.9,1.7,3.9,3.9v27.3 C35.5,33.8,33.8,35.5,31.6,35.5z M4.4,4.4v27.3h27.3V4.4H4.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2_1_",
    d: "M18,27.7H8.3V18h3.9v5.8H18V27.7z M27.7,18h-3.9v-5.8H18V8.3h9.7V18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRedimensionar01);
export default __webpack_public_path__ + "static/media/ico-redimensionar-01.46ee822a401ca374a3c3c369f3053827.svg";
export { ForwardRef as ReactComponent };